module.exports = __webpack_public_path__ + "media/images/icon__link-f6932eceafe4692c36ea8637cc396547.png";